import { ref } from 'vue';
import { defineStore } from 'pinia';
import { Network } from '@capacitor/network';

const networkStateStore = defineStore('network', () => {
  const isInitialised = ref(false);
  const isOnline = ref(true);

  Network.getStatus().then((status) => {
    isOnline.value = status.connected;
    isInitialised.value = true;
  });
  Network.addListener('networkStatusChange', (status) => {
    isOnline.value = status.connected;
  });

  return {
    isInitialised,
    isOnline,
  };
});

export default networkStateStore;
